import React from "react";
import styled from "styled-components";
import { calculateTotal } from "./priceCalculation.js";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

import moment from "moment";
const NewButton = withStyles({
  root: {
    backgroundColor: "#8dc695",
    color: "#fff",
    borderRadius: 0,
    width: "100%",
  },
})(Button);
const AlertBoxSuccess = styled.div`
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
`;
const AlertBoxFailure = styled.div`
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
`;
const BlueBox = styled.div`
  background-color: #b1d5f7;
  padding-top: 2px;
  margin-bottom: 20px;
  color: #606060;
  border-radius: 6px;
  padding: 20px;
  position: relative;
`;
const IndentBox = styled.div`
  position: relative;
  padding-left: 20px;
  /* color: #444; */
  width: 100%;
  color: #606060;
  height: 100%;
`;
const StyledList = styled.li`
  margin-top: 10px;
  margin-bottom: 10px;
  list-style-type: circle;
`;
const PriceBox = styled.div`
  position: absolute;
  right: 45px;
  float: right;
  bottom: 10px;
  max-width: 100px;
  @media (max-width: 600px) {
    position: relative;
    right: 0px;
    float: none;
    bottom: 0px;
  }
`;
const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  //max-width: 500px;
  grid-gap: 20px;
`;
export default class Summary extends React.Component {
  constructor() {
    super();
    this.state = {
      prices: [1950],
      error: false,
      errorMessage: "",
      open: false,
      formError: false,
      email: "",
      success: false,
      successMessage: "",
    };
  }
  handleFormData = (e) => {
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change);
  };
  validation = (e) => {
    if (this.state.email && this.state.company && this.state.name) {
      this.props.handleEmail(
        this.state.name,
        this.state.company,
        this.state.email,
        this.state.prices,
        this.state.telephone
      );
      const successMessage = (this.state.error || this.props.activeType === "custom-test")
        ? "Thank you for your interest in easy2survey. Someone from our sales team will contact you as soon as possible."
        : `Your proposal has been sent to ${
        this.state.email
        }. Please check your inbox (and spam) and you will find it attached in the message.`;
      this.setState({
        formError: false,
        open: false,
        success: true,
        successMessage,
      });
    } else {
      this.setState({ formError: true });
    }
  };
  componentWillReceiveProps(nextProps) {
    try {
      if (nextProps.message !== this.props.message || this.props.error) {
        throw Error(nextProps.message)
      }
      const prices = nextProps.activeProducts.map((product) => {
        const {
          type,
          countries,
          sampleSize,
          extraQuestions,
          adNumber,
          compNumber,
        } = nextProps[product];
        const checkForOtherComposition = nextProps[product].composition.filter(
          (val) => val.value === 0
        );
        if (checkForOtherComposition.length > 0) {
          this.setState({ otherComposition: true })
          throw Error(
            "Please leave your email address and we will contact you."
          );
        } else {
          this.setState({ otherComposition: false })
        }
        const sampleSizeReduced = sampleSize.reduce((acc, curr) => acc + curr);
        if ((sampleSizeReduced < 400) & (type === "Brand health checks")) {
          throw Error("Please select a sample size of 400 or higher");
        } else if (
          (sampleSizeReduced < 400) &
          (type === "Campaign evaluations")
        ) {
          throw Error("Please select a combined sample size of 400 or higher");
        } else if (
          adNumber < 1 &&
          type !== "Campaign evaluations" &&
          type !== "Brand health checks" &&
          type !== "Customer centricity scan" &&
          type !== "Employee engagement scan"
        ) {
          throw Error("A minimum of 1 ad is required");
        } else if (sampleSizeReduced < 150) {
          throw Error("Please select a sample size of 150 or higher");
        }
        if (countries && countries.length > 0) {
          const price = calculateTotal(
            type,
            countries,
            sampleSize,
            extraQuestions,
            adNumber || 1,
            compNumber || 1
          );
          return Math.round(price);
        } else {
          return "";
        }
      });
      this.setState({ prices: prices, error: false, errorMessage: "" });
    } catch (error) {
      this.setState({ error: true, errorMessage: error.message });
    }
  }
  handleChange = (input, component) => {
    const value = input.target ? input.target.value : input;
    this.setState({ [component]: value }, () => { });
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { activeType } = this.props
    return (
      <div>
        <BlueBox>
          {this.props.activeProducts.map((product, i) => {
            return (
              <IndentBox key={product}>
                <h3>
                  {this.props[product].title || `PROJECT TITLE FOR ${product}`}
                </h3>
                <p>{this.props[product].objective || "Project objective"}</p>
                {product[0] !== "employee-engagement-scan" &&
                  product[0] !== "customer-centricity-scan" ? (
                    <>
                      <ul>
                        <StyledList>
                          {this.props[product].sampleSize
                            ? `N = ${this.props[product].sampleSize.reduce(
                              (acc, curr) => acc + curr
                            )}`
                            : "N = 150"}
                        </StyledList>
                        {this.props[product].composition
                          ? this.props[product].composition.map((val, i) => {
                            return (
                              <StyledList key={val.label + i}>
                                Composition: {val.label}
                                {val.estimatedIr || val.targetDescription ? (
                                  <ul>
                                    <StyledList>
                                      IR:{" "}
                                      {val.estimatedIr <= 100 && val.estimatedIr && !isNaN(parseInt(val.estimatedIr)) > 0
                                        ? val.estimatedIr + " %"
                                        : ""}
                                    </StyledList>
                                    <StyledList>
                                      Target description:{" "}
                                      {val.targetDescription
                                        ? val.targetDescription
                                        : null}
                                    </StyledList>
                                  </ul>
                                ) : null}
                              </StyledList>
                            );
                          })
                          : null}
                        <StyledList>
                          {this.props[product].countries ? (
                            <>
                              Country(ies):{" "}
                              {this.props[product].countries.map(
                                (val) => val.label + ", "
                              )}
                            </>
                          ) : (
                              "Country: Netherlands"
                            )}
                        </StyledList>

                        {product[0] === "claim-test" ? (
                          <StyledList>
                            {" "}
                            Number of {this.props[product].type}:{" "}
                            {this.props[product].adNumber <= 15 && this.props[product].adNumber > 0
                              ? this.props[product].adNumber
                              : ""}
                          </StyledList>
                        ) : this.props[product].adNumber ? (
                          <StyledList>
                            {" "}
                            Number of {this.props[product].type}:{" "}
                            {this.props[product].adNumber}
                          </StyledList>
                        ) : null}
                        {/* {product[0] === "packaging-test" ? (
                        <StyledList>
                          Include current design:{" "}
                          {this.props[product].currentDesign.label}
                        </StyledList>
                      ) : null} */}
                        {product[0] === "campaign-evaluation" ? (
                          <StyledList>
                            Campaign message statements:{" "}
                            {this.props[product].campaignStatements}
                          </StyledList>
                        ) : null}
                        {this.props[product].extraQuestions > 0 ? (
                          <StyledList> Additional questions: Yes</StyledList>
                        ) : (
                            <StyledList> Additional questions: No </StyledList>
                          )}
                        {product[0] === "campaign-evaluation" ? (
                          <>
                            <StyledList>
                              Date:{" "}
                              {this.props[product].startDate.length > 0
                                ? moment(this.props[product].startDate).format(
                                  "L"
                                )
                                : null}{" "}
                              -{" "}
                              {this.props[product].endDate.length > 0
                                ? moment(this.props[product].endDate).format("L")
                                : null}
                            </StyledList>
                            <StyledList>
                              Number of campaign creatives:
                            <ul>
                                {this.props[product].campaignCreatives.map(
                                  (val, index) => {
                                    if (index === 0) {
                                      return (
                                        <StyledList key={"tv"}>
                                          TV: {val.label}
                                        </StyledList>
                                      );
                                    } else if (index === 1) {
                                      return (
                                        <StyledList key={"OOH"}>
                                          OOH: {val.label}
                                        </StyledList>
                                      );
                                    } else if (index === 2) {
                                      return (
                                        <StyledList key={"Digital"}>
                                          Digital: {val.label}
                                        </StyledList>
                                      );
                                    } else if (index === 3) {
                                      return (
                                        <StyledList key={"Print"}>
                                          Print: {val.label}
                                        </StyledList>
                                      );
                                    } else {
                                      return (
                                        <StyledList key={"Radio"}>
                                          Radio: {val.label}
                                        </StyledList>
                                      );
                                    }
                                  }
                                )}
                              </ul>
                            </StyledList>
                          </>
                        ) : null}
                      </ul>
                      <PriceBox>
                        {this.state.error.length > 0 ? (
                          <div />
                        ) : (
                            <>
                              <h3 style={{ color: "#888888" }}>PRICE</h3>
                              <p>
                                {this.state.error || ((this.props[product].adNumber > 15 || this.props[product].adNumber === 0) && product[0] === "claim-test") || product[0] === "custom-test" ? (
                                  "N/A"
                                ) : (
                                    <span>&euro; {this.state.prices[i]},-</span>
                                  )}
                              </p>
                            </>
                          )}
                      </PriceBox>
                    </>
                  ) : null}
              </IndentBox>
            );
          })}
        </BlueBox>
        {this.state.error ? (
          <div>
            <AlertBoxFailure>{this.state.errorMessage}</AlertBoxFailure>
          </div>
        ) : (
            <div />
          )}
        <ButtonContainer style={{ clear: "both" }}>
          {/* <NewButton
              variant="contained"
              onClick={this.props.addProducts}
              style={{ fontWeight: "900", gridColumn: "1/2", gridRow: "1/2" }}
            >
              Order more products
            </NewButton> */}
          <div />
          {(this.state.otherComposition || this.props.activeType === "custom-test" || this.props.activeType === "customer-centricity-scan" || this.props.activeType === "employee-engagement-scan") ? (
            <div />
          ) : (
              <div>
                <NewButton
                  variant="contained"
                  onClick={this.props.orderProducts}
                  style={{
                    fontWeight: "900",
                    gridColumn: "2/3",
                    gridRow: "2/3",
                    width: "100%",
                  }}
                >
                  Order
              </NewButton>
              </div>
            )}
          <div />
          <NewButton
            variant="contained"
            onClick={this.handleClickOpen}
            style={{
              fontWeight: "900",
              gridColumn: "2/3",
              gridRow: "2/3",
              width: "100%",
            }}
          >
            {this.state.otherComposition
              ? "Leave your email address here"
              : "Request proposal"}
          </NewButton>
          {this.state.success ? (
            <>
              <div />
              <AlertBoxSuccess>{this.state.successMessage}</AlertBoxSuccess>
            </>
          ) : null}
          {this.state.otherComposition || this.props.activeType === "custom-test" ? (
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="form-dialog-title">Contact</DialogTitle>
              <DialogContent>
                <DialogContentText
                  style={{ color: this.state.formError ? "red" : "initial" }}
                >
                  {this.state.formError
                    ? "Please fill out every field!"
                    : "Please leave your name, company, telephone number and your email address below. Our easy2survey sales team will contact you as soon as possible."}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  name="name"
                  label="Name"
                  type="text"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  name="company"
                  label="Company"
                  type="text"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  name="telephone"
                  label="Telephone Number"
                  type="tel"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  name="email"
                  label="Email Address"
                  type="email"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
              </Button>
                <Button onClick={this.validation} color="primary">
                  Send
              </Button>
              </DialogActions>
            </Dialog>) :
            (<Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="form-dialog-title">Send proposal</DialogTitle>
              <DialogContent>
                <DialogContentText
                  style={{ color: this.state.formError ? "red" : "initial" }}
                >
                  {this.state.formError
                    ? "Please fill out every field!"
                    : "To receive your proposal, please leave your name, company and your email address below. The proposal will be sent to this email address.  (Be sure to check your spam folder)"}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  name="name"
                  label="Name"
                  type="text"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  name="company"
                  label="Company"
                  type="text"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  name="email"
                  label="Email Address"
                  type="email"
                  onChange={(e) => this.handleFormData(e)}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
              </Button>
                <Button onClick={this.validation} color="primary">
                  Send
              </Button>
              </DialogActions>
            </Dialog>)
          }
        </ButtonContainer>
      </div>
    );
  }
}
